<!-- homepage -->
<div class="wrapper" *ngIf="this.homepage">
  <div class="topDestination" *ngFor="let destination of classements">
    <div class="titreDestination" *ngIf="destination.produits.length > 0">
      <h2>{{ destination.name }}</h2>
      <a [href]="'/d/' + destination.name" [title]="'Destination : ' + destination.name"
        [attr.aria-label]="'Destination : ' + destination.name">En voir plus</a>
    </div>
    <div class="box">
      <ng-container *ngTemplateOutlet="cardProduitTemplate; context: destination">
      </ng-container>
    </div>
  </div>
</div>

<!-- page Destination -->
<div class="wrapper" *ngIf="this.destinationpage">
  <h1 class="titreh110">{{ titre }}</h1>

  <div class="tabs-wrapper">
    <input type="radio" name="tab" id="tab1" class="tab-head" checked="checked" />
    <label for="tab1">{{destination.toLocaleUpperCase()}}</label>
    <ng-container *ngFor="let contenu of responseContenudestination.contenudestination; let index = index">
      <input type="radio" name="tab" [id]="'tab'+(index + 2)" class="tab-head" />
      <label [for]="'tab'+(index + 2)">{{contenu.titre}}</label>
    </ng-container>
    <div class="tab-body-wrapper">
      <div id="tab-body-1" class="tab-body">
        <div class="topDestination" *ngFor="let categ of classements">
          <div class="titreDestination" *ngIf="categ.produits.length > 0">
            <h2>{{ categ.name }}</h2>
            <a [href]="'/d/' + destination + '/c/' + categ.slug"
              [title]="'Destination : ' + destination + ', catégorie : ' + categ.name"
              [attr.aria-label]="'Destination : ' + destination + ', catégorie : ' + categ.name">En voir plus</a>
          </div>
          <div class="box">
            <ng-container *ngTemplateOutlet="cardProduitTemplate; context: categ">
            </ng-container>
          </div>
        </div>
      </div>
      <div *ngFor="let contenu of responseContenudestination.contenudestination; let index = index"
        [id]="'tab-body-'+(index + 2)" class="tab-body">
        <div class="wrapList">
          <ul>
            <p class="listDestination" [innerHTML]="contenu.contenu"></p>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="tabs">

    <div class="tab">
      <input type="radio" id="tab-1" name="tab-group-1" checked>
      <label for="tab-1">{{destination.toLocaleUpperCase()}}</label>
      <div class="content">
        <div class="topDestination" *ngFor="let categ of classements">
          <div class="titreDestination" *ngIf="categ.produits.length > 0">
            <h2>{{ categ.name }}</h2>
            <a [href]="'/d/' + destination + '/c/' + categ.slug"
              [title]="'Destination : ' + destination + ', catégorie : ' + categ.name"
              [attr.aria-label]="'Destination : ' + destination + ', catégorie : ' + categ.name">En voir plus</a>
          </div>
          <div class="box">
            <ng-container *ngTemplateOutlet="cardProduitTemplate; context: categ">
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="tab" *ngFor="let contenu of responseContenudestination.contenudestination; let index = index">
      <input type="radio" [id]="'tab-'+(index+2)" name="tab-group-1">
      <label [for]="'tab-'+(index+2)">{{contenu.titre.toLocaleUpperCase()}}</label>

      <div class="content">
        <div class="wrapList">
          <ul>
            <p class="listDestination" [innerHTML]="contenu.contenu"></p>
          </ul>
        </div>
      </div>
    </div>

  </div> -->


  <!-- <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center" *ngIf="destination"
    (selectedTabChange)="changescroll($event)">
    <mat-tab [label]="destination.toLocaleUpperCase()">
      <div class="topDestination" *ngFor="let categ of classements">
        <div class="titreDestination" *ngIf="categ.produits.length > 0">
          <h2>{{ categ.name }}</h2>
          <a [href]="'/d/' + destination + '/c/' + categ.slug"
            [title]="'Destination : ' + destination + ', catégorie : ' + categ.name"
            [attr.aria-label]="'Destination : ' + destination + ', catégorie : ' + categ.name">En voir plus</a>
        </div>
        <div class="box">
          <ng-container *ngTemplateOutlet="cardProduitTemplate; context: categ">
          </ng-container>
        </div>
      </div>
    </mat-tab>
    <mat-tab *ngFor="let contenu of responseContenudestination.contenudestination" [label]="contenu.titre">
      <div class="wrapList">
        <ul>
          <p class="listDestination" [innerHTML]="contenu.contenu"></p>
        </ul>
      </div>
    </mat-tab>
  </mat-tab-group> -->
</div>

<!-- page Categorie ou Tag -->
<div class="wrapper" infinite-scroll (scrolled)="appendItems()" *ngIf="this.otherpage">
  <div class="wrapcenter">
    <h1 class="titreh110">{{ titre }}</h1>
    <div class="box">
      <ng-container *ngTemplateOutlet="cardProduitTemplate; context: myProduits">
      </ng-container>
    </div>
  </div>
</div>

<ng-template #cardProduitTemplate let-produits="produits">
  <cardProduit [produit]="produit" [categorie]="categorie" [destination]="destination" [tag]="tag" [search]="search"
    *ngFor="let produit of produits"></cardProduit>
</ng-template>